
<template>
    <!-- メニュータグ: PC表示 -->
    <!-- プランアイコン -->
    <ul v-if="innerWidth > 744" class="p-menu-plan-block__status p-menu-plan-block__status--benefit">
        <template v-for="item in getPlanIcon">
            <li :key="item.iconCd" v-if="item.isAvailable || (item.iconCd && item.iconNm)" 
            :class="[
                item.iconNm !== 'カフェ'
                  ? 'mr-1'
                  : 'mr-1 cafe-icon'
              ]">
                {{ item.iconNm }}
            </li>
        </template>
    </ul>
    <!-- メニュータグ: SP表示 -->
    <div v-else class="sm_tag">
        <!-- プランアイコン -->
        <ul class="sm_tag_other_list">
            <template v-for="item in getPlanIcon">
                <li :key="item.iconCd" v-if="item.isAvailable || (item.iconCd && item.iconNm)"
                :class="[
                  item.iconNm !== 'カフェ'
                    ? 'sm_tag_other_item'
                    : 'sm_tag_other_item cafe-icon'
                ]">
                    {{ item.iconNm }}
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
export default {
  props: {
    menu: {
      type: Object,
    },
    plan: {
        type: Object,
    }
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      planIcons: [],
      initProp: {
        menu:false,
        plan: false
      }
    };
  },
  mounted() {
    this.planIcons = Array.isArray(this.plan.planIcons) ? _.cloneDeep(this.plan.planIcons) : [];
    if(this.plan) this.initProp.plan = true;
    if(this.menu) this.initProp.menu = true;
  },
  watch: {
    plan: {
      deep: true,
      handler(val) {
        this.planIcons = Array.isArray(val?.planIcons) ? _.cloneDeep(val.planIcons) : [];
        if(val){
          this.initProp.plan = true;
        }
      }
    },
    menu: {
      deep: true,
      handler(val) {
        if(val){
          this.initProp.menu = true;
        }
      }
    },
    initProp: {
      deep: true,
      handler(val) {
        if(val.plan && val.menu){
          this.getIconCafe();
        }
      }
    }
  },
  computed: {
    getPlanIcon() {
      let result =  this.planIcons?.length > 0 ? _.cloneDeep(this.planIcons) : [];
      return result;
    }
  },
  methods: {
    async getIconCafe() {
      const idData = [
        {
          no: "0", 
          targetType: "1",
          id: "0000000" // 仮の値の為、BFFでカフェの契約IDをセットすること
        }
      ];
      const params = {
        idData: idData,
        iconData: this.makeIconReqParamsPlanInfo(this.plan)
      };
      const res = await this.$repositories('coupon').getIcons(params);
      if (res?.data?.availableIcon?.[0]) {
        this.planIcons.push({
          iconNm: res.data.availableIcon[0].iconNm,
          iconCd: res.data.availableIcon[0].iconCD,
          isAvailable: true
        });
      }
    },
    makeIconReqParamsPlanInfo(planDetail) {
      const iconData = [
        {
          no: 0,
          catLrgClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catLrgClassCd || '',
          catMidClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catMidClassCd || '',
          catSmlClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catSmlClassCd || '',
          menuNo: this.menu?.menuBasicInfo?.menuNo || '',
          planId: planDetail?.planBasicInfo?.planId || '',
          areaLrgClassCd: this.menu?.menuBasicInfo?.areaInfomation?.areaLrgClassCd || '',
          areaMidClassCd:  this.menu?.menuBasicInfo?.areaInfomation?.areaMidClassCd || '',
          areaSmlClassCd:  this.menu?.menuBasicInfo?.areaInfomation?.areaSmlClassCd || '',
          areaDtlClassCd:  this.menu?.menuBasicInfo?.areaInfomation?.areaDtlClassCd || '',
          receivableFlag: '1',
          ticketExclusionFlag: planDetail?.planUsage?.usageDetail?.ticketExclusionFlag || '',
          buppanExclusionFlag: planDetail?.planUsage?.usageDetail?.buppanExclusionFlag || '',
          famiExclusionFlag: planDetail?.planUsage?.usageDetail?.famiExclusionFlag || ''
        }
      ];
      return iconData;
    }
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.pointer-cusor {
  cursor: pointer;
}

@media screen and (max-width: $contentWidthS) {
  .sm {
    &_container {
      border-radius: 6px;
      box-shadow: 0 0 6px #00000029;
    }
    &_wrapper {
      padding: 20px 12px;
    }
    &_aeSalary {
      display: block;
      margin: 0 -12px 16px;
      padding: 9px 0;
      font-size: 13px;
      line-height: 19.5px;
      text-align: center;
      background-color: #259BEE;
      color: white;
      font-weight: bold;
    }
    &_title {
      font-size: 16px;
      margin-bottom: 12px;
      color: #1f2021;
    }
    &_discount {
      font-size: 12px;
      margin-bottom: 4px;
      color: #1f2021;
      span {
        color: #DD0000;
        font-weight: bold;
      }
    }
    &_tag {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      &_benepo {
        margin-right: 8px;
        padding: 2px 8px;
        font-size: 10px;
        line-height: 15px;
        color: #1f2021;
        background-color: #FDF1F1;
      }
      &_other {
        &_list {
          display: flex;
          align-items: center;
        }
        &_item {
          display: block;
          margin-right: 8px;
          padding: 2px 8px;
          font-size: 10px;
          line-height: 15px;
          color: #1f2021;
          background-color: #FDF1F1;
        }
      }
    }
    &_planIcon {
      margin-bottom: 0;
    }
  }
}
</style>
